module.exports = __webpack_public_path__ + "img/hongkong-lpf.41a4114c.png";